import logo from './logo.svg';
import './App.css';
import React from "react";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import Home from "./pages/Home";
import MainComponent from "./pages/MainComponent";
import Footer from "./pages/Footer";
import AboutUs from "./pages/AboutUs"; 
import ContactUs from "./pages/ContactUs";
import Terms from "./pages/TermsAndConditions"; 
import Privacy from "./pages/PrivacyPolicy";
import Disclaimer from "./pages/Disclaimer";
import Sitemap from "./pages/Sitemap"
import EmailAccount from "./pages/EmailAccountGuide";
import JpegToPdf from "./pages/JpegToPdfConverter";
import JpgToPdf from "./pages/JpgToPdfConverter";
import PngToPdfConverter from "./pages/PngToPdfConverter";
import AdobePDFBlog from "./pages/AdobePDFBlog";
import PDFBlog from "./pages/PDFBlog";
import DNSBlog from "./pages/DNSBlog";
import NotepadVsVSCode from "./pages/NotepadVsVSCode";
import NetBeansVsEclipse from "./pages/NetBeansVsEclipse";
import VSCodeVsNetBeans from "./pages/VSCodeVsNetBeans";
import SublimeVsVs from "./pages/SublimeVsVs";
import NotepadVsSublime from "./pages/NotepadVsSublime";
import CodePenGuide from "./pages/CodePenGuide";
import EclipseShortcuts from "./pages/EclipseShortcuts";
import EclipsePluginsBlog from "./pages/EclipsePluginsBlog";
import EclipseBlog from "./pages/EclipseBlog";
import NetBeansShortcuts from "./pages/NetBeansShortcuts";
import NetbeansPlugins from "./pages/NetbeansPlugins";
import Netbeans from "./pages/Netbeans";
import VsCodeShortcuts from "./pages/VsCodeShortcuts";
import VsCodePlugins from "./pages/VsCodePlugins";
import VsCode from "./pages/VsCode";
import XMLvsJSON from "./pages/XMLvsJSON";
import XML from "./pages/XML";
import JsonViewerTool from "./pages/JsonViewerTool";
import JsonViewers from "./pages/JsonViewers";
import SublimeShortcuts from "./pages/SublimeShortcuts";
import SublimeTextPlugins from "./pages/SublimeTextPlugins";
import GitHubBlog from "./pages/GitHubBlog";
import GitBasicsBlog from "./pages/GitBasicsBlog";
import SublimeTextBlog from "./pages/SublimeTextBlog";
import NotepadShortcuts from "./pages/NotepadShortcuts";
import NotepadPlugins from "./pages/NotepadPlugins";
import NotepadBlog from "./pages/NotepadBlog";
import Http502Blog from "./pages/Http502Blog";
import RepublicDayBlog from "./pages/RepublicDayBlog";
import Cxx from "./pages/Cxx";
import CronJobs from "./pages/CronJobs";
import NewYearBlog from "./pages/NewYearBlog";
import WinSCPBlog from "./pages/WinSCPBlog";
import CPanelPasswordGuide from "./pages/CPanelPasswordGuide";
import CPanelCacheGuide from "./pages/CPanelCacheGuide";
import FileZillaTutorial from "./pages/FileZillaTutorial";
import SubdomainTutorial from "./pages/SubdomainTutorial";
import DomainSetup from "./pages/DomainSetup";
import SSLSetupBlog from "./pages/SSLSetupBlog";
import BackupGuide from "./pages/BackupGuide";
import MySQLSetupBlog from "./pages/MySQLSetupBlog";
import FTPSetupGuide from "./pages/FTPSetupGuide";
import DiwaliBlog from "./pages/DiwaliBlog";
import ShutterstockGuide from "./pages/ShutterstockGuide";
import PhpVersionGuide from "./pages/PhpVersionGuide";
import DussehraBlog from "./pages/DussehraBlog";
import NavratriBlog from "./pages/NavratriBlog";
import MolecularComputingBlog from "./pages/MolecularComputingBlog";
import TurboPayzBlog from "./pages/TurboPayzBlog";
import GaneshChaturthi from "./pages/GaneshChaturthi";
import TeachersDayBlog from "./pages/TeachersDayBlog";
import PersonalDevelopmentBlog from "./pages/PersonalDevelopmentBlog";
import QRCodeGenerator from "./pages/QRCodeGenerator";
import BarcodeGenerator from "./pages/BarcodeGenerator";
import OwalaBlog from "./pages/OwalaBlog";
import Dynamicmeta from "./pages/Dynamicmeta";
import ScrollToTop from "./pages/ScrollToTop";
import NotFound from './pages/NotFound';
import ErrorBoundary from './pages/ErrorBoundary';
import ColorPickerTool from "./pages/ColorPickerTool";




function App() {
  return (
  <>
  <HelmetProvider>
   <ErrorBoundary>
      <Router>
        <Routes>
          <Route path="/" element={<Home/>} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/contactus.html" element={<ContactUs />} />
          <Route path="/terms.html" element={<Terms />} />
          <Route path="/privacy.html" element={<Privacy />} />
          <Route path="/disclaimer.html" element={<Disclaimer />} />
          <Route path="/sitemap.html" element={<Sitemap />} />
          <Route path="/email_accounts.html" element={<EmailAccount />} />
          <Route path="/jpeg_to_pdf.html" element={<JpegToPdf />} />
          <Route path="/jpg_to_pdf.html" element={<JpgToPdf />} />
          <Route path="/png_to_pdf.html" element={<PngToPdfConverter />} />
          <Route path="/adobe_pdf.html" element={<AdobePDFBlog />} />
          <Route path="/pdf.html" element={<PDFBlog />} />
          <Route path="/dns.html" element={<DNSBlog />} />
          <Route path="/notepad_vs_vs.html" element={<NotepadVsVSCode />} />
          <Route path="/netbeans_vs_eclipse.html" element={<NetBeansVsEclipse />} />
          <Route path="/vs_vs_netbeans.html" element={<VSCodeVsNetBeans />} />
          <Route path="/sublime_vs_vscode.html" element={<SublimeVsVs />} />
          <Route path="/notepad_vs_sublime.html" element={<NotepadVsSublime />} />
          <Route path="/codepen.html" element={<CodePenGuide />} />
          <Route path="/eclipse_shortcut.html" element={<EclipseShortcuts />} />
          <Route path="/eclipse_plugins.html" element={<EclipsePluginsBlog />} />
          <Route path="/eclipse.html" element={<EclipseBlog />} />
          <Route path="/netbeans_shortcuts.html" element={<NetBeansShortcuts />} />
          <Route path="/netbeans_plugins.html" element={<NetbeansPlugins />} />
          <Route path="/netbeans.html" element={<Netbeans />} />
          <Route path="/vscode_shortcuts.html" element={<VsCodeShortcuts />} />
          <Route path="/vscode_plugin.html" element={<VsCodePlugins />} />
          <Route path="/vscode.html" element={<VsCode />} />
          <Route path="/jsonvsxml.html" element={<XMLvsJSON />} />
          <Route path="/xml.html" element={<XML />} />
          <Route path="/json_viewer_tool.html" element={<JsonViewerTool />} />
          <Route path="/json_viewers.html" element={<JsonViewers />} />
          <Route path="/sublime_shortcut.html" element={<SublimeShortcuts />} />
          <Route path="/sublime_plugins.html" element={<SublimeTextPlugins />} />
          <Route path="/github.html" element={<GitHubBlog />} />
          <Route path="/git.html" element={<GitBasicsBlog />} />
          <Route path="/sublime.html" element={<SublimeTextBlog />} />
          <Route path="/notepad_shortcuts.html" element={<NotepadShortcuts />} />
          <Route path="/notepad_plugins.html" element={<NotepadPlugins />} />
          <Route path="/notepadplus.html" element={<NotepadBlog />} />
          <Route path="/http_502.html" element={<Http502Blog />} />
          <Route path="/republic.html" element={<RepublicDayBlog />} />
          <Route path="/cxx.html" element={<Cxx />} />
          <Route path="/cronjobs.html" element={<CronJobs />} />
          <Route path="/newyear.html" element={<NewYearBlog />} />
          <Route path="/winscp.html" element={<WinSCPBlog />} />
          <Route path="/pwdchange.html" element={<CPanelPasswordGuide />} />
          <Route path="/cache.html" element={<CPanelCacheGuide />} />
          <Route path="/filezilla.html" element={<FileZillaTutorial />} />
          <Route path="/subdomain.html" element={<SubdomainTutorial />} />
          <Route path="/domain.html" element={<DomainSetup />} />
          <Route path="/ssl.html" element={<SSLSetupBlog />} />
          <Route path="/backup.html" element={<BackupGuide />} />
          <Route path="/mysql.html" element={<MySQLSetupBlog />} />
          <Route path="/ftp.html" element={<FTPSetupGuide />} />
          <Route path="/diwali.html" element={<DiwaliBlog />} />
          <Route path="/shutterstock.html" element={<ShutterstockGuide />} />
          <Route path="/phpversion.html" element={<PhpVersionGuide />} />
          <Route path="/dussehra.html" element={<DussehraBlog />} />
          <Route path="/navratri.html" element={<NavratriBlog />} />
          <Route path="/molecular-computing.html" element={<MolecularComputingBlog />} />
          <Route path="/turbopayz.html" element={<TurboPayzBlog />} />
          <Route path="/ganeshchaturthi.html" element={<GaneshChaturthi />} />
          <Route path="/teachersday.html" element={<TeachersDayBlog />} />
          <Route path="/personaldevelopment.html" element={<PersonalDevelopmentBlog />} />
          <Route path="/free-qr-generator" element={<QRCodeGenerator />} />
          <Route path="/free-barcode-generator" element={<BarcodeGenerator />} />
          <Route path="/owala-water-bottle" element={<OwalaBlog />} />
          <Route path="/colortool.html" element={<ColorPickerTool />}/>
            {/* Catch-all route for 404 */}
          }
          <Route path="*" element={<NotFound/>}/>

        </Routes>
      </Router>
      </ErrorBoundary>
    </HelmetProvider>
    <ScrollToTop/>
  </>
  );
}

export default App;
